export type WorkingDayStatKey = 'visits' | 'waiting' | 'inChair' | 'done';

/**
 * Deep-link from header working-day stat tiles to the matching appointments view.
 */
export function buildWorkingDayStatLink(dateKey: string, stat: WorkingDayStatKey): string {
  const params = new URLSearchParams({ date: dateKey });
  switch (stat) {
    case 'visits':
      params.set('tab', 'all');
      return `/appointments/list?${params.toString()}`;
    case 'waiting':
      params.set('segment', 'waiting');
      return `/appointments/waiting-room?${params.toString()}`;
    case 'inChair':
      params.set('segment', 'in_chair');
      return `/appointments/waiting-room?${params.toString()}`;
    case 'done':
      params.set('tab', 'past');
      return `/appointments/list?${params.toString()}`;
  }
}
